import React, { useState,useEffect } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Tooltip } from "react-tooltip";
import CheckCurrentPlan from "../../../../components/CheckCurrentPlan";
import { submitTemplate } from "../../../../utils/payPalButtonApi";
import '../../../../assets/css/loader.css'; 

//Import Widgets
import CommonTemplate from "../../../../components/Apps/PayPalButton/Template/CommonTemplate";

//Import Tabs
import PaymentTab from "../../../../components/Apps/PayPalButton/PaymentTab";
import ButtonTab from "../../../../components/Apps/PayPalButton/ButtonTab";
import StyleTab from "../../../../components/Apps/PayPalButton/StyleTab";

export default function CreatePayPalButton() {
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState(true);
    const [showTemplateSelection, setShowTemplateSelection] = useState(true);
    const [activeSection, setActiveSection] = useState("Payment");
    const [activeTemplateSection, setActiveTemplateSection] = useState("Checkout_Temp");
    const [selectedLayout, setSelectedLayout] = useState("checkout_layout");
    const [selectedTemplateImage, setSelectedTemplateImage] = useState("checkout.png");
    const [renameWidgetNameModel, setRenameWidgetNameModel] = useState(false);
    const [widgetName, setWidgetName] = useState("Untitled PayPal Button");
    const [newWidgetName, setNewWidgetName] = useState("");
    
    const [payPalButtonTabData, setPayPalButtonTabData] = useState({
        is_website_frontend: "", 
        seller_paypal_email: "", 
        payment_button_type: "Checkout", 
        product_name: "", 
        localization_type: "English (United States)", 
        currency_type: "USD", 
        price: 5, 
        shipping_price: 0, 
        tax_type: "None", 
        tax_value: 0, 
        billing_interval: 'Monthly', 
        is_show_hecurring_subscription: 1, 
        donation_type: 'Optional', 
        redirect_url: "", 
        text_above_button: "", 
        button_text: "", 
        button_elements: [], 
        payment_systems_icons: [], 
        button_width: "auto",
        button_size: "17",
        button_shape_type: "normal-shape",
        button_border_size: 1,
        button_color: "",
        button_text_color: "",
        button_border_color: "",
        paypal_logo_color: "",
        custom_css: "",    
        custom_js: "",    
    });

    // Set Template Setting And Texts when activeTemplateSection changes
        useEffect(() => {
            let product_name = "";
            let text_above_button = "";
            let button_text = "";
            let button_elements = [];
            let payment_systems_icons = [];
            let button_color = "";
            let button_text_color = "";
            let button_border_color = "";
            let paypal_logo_color = "";
            let button_shape_type = "";
        
            switch (activeTemplateSection) {
                case "Checkout_Temp":
                    product_name = "New Shiny Cup every month";
                    text_above_button = "";
                    button_text = "Buy now with";
                    button_elements = ["Button Text","Paypal Icon","Paypal Text"];
                    payment_systems_icons = ["Visa","Mastercard","Amex","Discover"];
                    button_color = "#fdc338";
                    button_text_color = "#000";
                    button_border_color = "#fff";
                    paypal_logo_color = "Original";
                    button_shape_type = "large-shape";
                    break;
                case "Pay_With_PayPal_Temp":
                    product_name = "";
                    text_above_button = "";
                    button_text = "Pay with";
                    button_elements = ["Button Text","Paypal Icon","Paypal Text"];
                    payment_systems_icons = [];
                    button_color = "#ffc43b";
                    button_text_color = "#000";
                    button_border_color = "#fff";
                    paypal_logo_color = "Original";
                    button_shape_type = "medium-shape";
                    break;
                case "Donation_Temp":
                    product_name = "";
                    text_above_button = "Share your ❤️ Buy me a ☕ ";
                    button_text = "Donate";
                    button_elements = ["Button Text","Paypal Icon"];
                    payment_systems_icons = [];
                    button_color = "#fddfd7";
                    button_text_color = "#000";
                    button_border_color = "#facfca";
                    paypal_logo_color = "Original";
                    button_shape_type = "large-shape";
                    break;
                case "Subscription_Temp":
                    product_name = "";
                    text_above_button = "";
                    button_text = "Subscribe with";
                    button_elements = ["Button Text","Paypal Text"];
                    payment_systems_icons = ["Visa","Mastercard","Amex","Discover"];
                    button_color = "#3874b5";
                    button_text_color = "#fff";
                    button_border_color = "#facfca";
                    paypal_logo_color = "White";
                    button_shape_type = "medium-shape";
                    break;
                default:
                    product_name = "";
                    text_above_button = "";
                    button_text = "";
                    button_elements = [];
                    payment_systems_icons = [];
                    button_color = "";
                    button_text_color = "";
                    button_border_color = "";
                    paypal_logo_color = "";
                    button_shape_type = "";
            }
        
            // Update setPayPalButtonTabData state with the data
            setPayPalButtonTabData((prevData) => ({
                ...prevData,
                product_name: product_name,
                text_above_button: text_above_button,
                button_text: button_text,
                button_elements: button_elements,
                payment_systems_icons: payment_systems_icons,
                button_color: button_color,
                button_text_color: button_text_color,
                button_border_color: button_border_color,
                paypal_logo_color: paypal_logo_color,
                button_shape_type: button_shape_type,
            }));
        
        }, [activeTemplateSection]);

    // Open Widget Name Popup
    const openRenameWidgetNamePopup = () => {
        setNewWidgetName(widgetName);
        setRenameWidgetNameModel(true);
        document.body.classList.add("popup-open");
    };

    // Close Widget Name Popup
    const closeRenameWidgetNamePopup = () => {
        setRenameWidgetNameModel(false);
        document.body.classList.remove("popup-open");
    };

    // Save Widget Name Popup
    const saveWidgetName = () => {
        if (newWidgetName.trim() !== "") {
            setWidgetName(newWidgetName); 
        }
        closeRenameWidgetNamePopup();
    };

    // Function to update values dynamically
    const updatePayPalButtonTabData = (key, value) => {
        setPayPalButtonTabData((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const handleContinueTemplate = () => {
      setShowTemplateSelection(false);
      setIsSubmitting(false);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          setSelectedLayout(layoutTypeValue);
      } else {
          alert('Please select a template');
      }
  }; 

  const menuItems = [
      { key: "Payment", icon: "payment.png", label: "Payment" },
      { key: "Button", icon: "button.png", label: "Button" },
      { key: "Style", icon: "style.png", label: "Style" },
  ];

  // Handle Source Tab input change
  const handleActiveTemplateInputChange = (event) => {
      setActiveTemplateSection(event.target.value);
      //Get the currently checked radio button
      const selectedRadio = document.querySelector('input[name="app_template_type"]:checked');
      if (selectedRadio) {
          const layoutTypeValue = selectedRadio.dataset.layout_type;
          const template_image = selectedRadio.dataset.template_image;
          setSelectedLayout(layoutTypeValue);
          setSelectedTemplateImage(template_image);
      } else {
          alert('Please select a template');
      }
  };

  //Submit Review data
  const submitForm = async (e) => {
      e.preventDefault();

      setIsSubmitting(true);
      try {
        // Collect data from refs
        const settingsArray = Object.entries(payPalButtonTabData).map(([key, value]) => ({
            setting_key: key,
            setting_value: value,
        }));

          // Collect data from refs
          const payload = {
                name: widgetName,
                template_name: activeTemplateSection,
                template_image: selectedTemplateImage,
                layout_name: selectedLayout,
                layout_type: selectedLayout,
                app_type: "PayPal_Button",
                settings: settingsArray,
          };
          
          //Api Call
          let api_response = await submitTemplate(payload);

          //Check Responce
          if (api_response.status === true) {
                toast.success(api_response.message);
                // Redirect after 2 seconds
                setTimeout(() => {
                    navigate('/customer/apps/paypal-button');
                }, 2000); 
          } else {
              toast.error(api_response.message);
          }
      } catch (error) {
          toast.error('Oops Something Wrong. Please Try Again!' + error.message);
      } finally {
          setIsSubmitting(false);
      }
  };

  return (
    <>
      <div className="create-goole-reviews-all">
            <CheckCurrentPlan from_page={true} app_name="PayPal Button" app_type="PayPal_Button" app_slug="paypal-button"/>
            {showTemplateSelection ? (
                <div className="create-goole-reviews-side">
                    <span>Select a template to start with</span>
                    <div className="card h-100">
                        <div className="label-box-flex">
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Checkout_Temp" data-layout_type="checkout_layout" data-template_image="checkout.png" checked={activeTemplateSection === "Checkout_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className="card card-body">
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/paypal-button/templates/checkout.png`} alt="checkout" />
                                    </div> 
                                    <div className="content_sub">Checkout</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Pay_With_PayPal_Temp" data-layout_type="pay_with_paypal_layout" data-template_image="pay-with-paypal.png" checked={activeTemplateSection === "Pay_With_PayPal_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/paypal-button/templates/pay-with-paypal.png`} alt="pay-with-paypal" />
                                    </div>
                                    <div className="content_sub">Pay with PayPal</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Donation_Temp" data-layout_type="donation_layout" data-template_image="donation.png" checked={activeTemplateSection === "Donation_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/paypal-button/templates/donation.png`} alt="donation" />
                                    </div>
                                    <div className="content_sub">Donation</div>
                                </div>
                            </label>
                            <label className="card-radio-btn">
                                <input type="radio" name="app_template_type" className="card-input-element d-none" value="Subscription_Temp" data-layout_type="subscription_layout" data-template_image="subscription.png" checked={activeTemplateSection === "Subscription_Temp"} onChange={handleActiveTemplateInputChange} />
                                <div className='card card-body'>
                                    <div className="content_head">
                                        <img src={`${process.env.PUBLIC_URL}/paypal-button/templates/subscription.png`} alt="subscription" />
                                    </div>
                                    <div className="content_sub">Subscription</div>
                                </div>
                            </label>
                        </div>
                    </div>
                    <div className="continue-template">
                        <button onClick={handleContinueTemplate}>Continue with this template</button>
                    </div>
                </div>
            ) : (
                <>
                    <div className="overlay-side-baar">
                        <div className="side-baar-inner-one">
                            <ul>
                                {menuItems.map((item) => (
                                    <li key={item.key}>
                                        <button
                                            className={activeSection === item.key ? "active" : ""}
                                            onClick={() => setActiveSection(item.key)}
                                        >
                                            <img
                                                src={`${process.env.PUBLIC_URL}/paypal-button/icons/${item.icon}`}
                                                alt={`${item.key} icon`}
                                            />
                                            <span>{item.label}</span>
                                        </button>
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className="side-baar-inner-tow">
                            {/* Conditional Rendering for Sections */}
                            {activeSection === "Payment" && (
                              <PaymentTab updatePayPalButtonTabData={updatePayPalButtonTabData} payPalButtonTabData={payPalButtonTabData} />
                            )}
                            {activeSection === "Button" && (
                              <ButtonTab updatePayPalButtonTabData={updatePayPalButtonTabData} payPalButtonTabData={payPalButtonTabData} />
                            )}
                            {activeSection === "Style" && (
                              <StyleTab updatePayPalButtonTabData={updatePayPalButtonTabData} payPalButtonTabData={payPalButtonTabData}/>
                            )}
                        </div>
                    </div>
                </>
            )}
            <div className="create-goole-reviews-right">
                <div className="content-wrapper count-add-class">
                    <div className="source-header-row">
                        <h2><Link to="/customer/apps/paypal-button"><i className="fa fa-angle-left" aria-hidden="true"></i></Link> Back</h2>
                        <div className="untitled-widget-name">
                            <button onClick={openRenameWidgetNamePopup} data-tooltip-id="rename-tooltip"><img src={`${process.env.PUBLIC_URL}/paypal-button/paypal-button.svg`} alt="paypal-button"/>{ widgetName }</button>
                            <Tooltip id="rename-tooltip" place="top" content="Rename Widget" />
                        </div>
                        <div className='submit-google-review'>
                          <button type="button" onClick={submitForm} className={`form-button ${isSubmitting ? 'disabled' : ''}`} disabled={isSubmitting}>Publish</button>
                          <Link to="/customer/apps/paypal-button/pricing/single" className="view-plan">View Plans</Link>
                          <Link to="/customer/apps/paypal-button" className="close-button">Close</Link></div>
                    </div>
                    <div className="source-title-row">PayPal Button <i className="fa fa-angle-right" aria-hidden="true"></i> <strong>Connect</strong></div>

                    {/*Call Common template*/}
                    <CommonTemplate selectedTemplate={activeTemplateSection} payPalButtonTabData={payPalButtonTabData} />
                </div>
            </div>
        </div>

        {/* Rename Popup */}
        {renameWidgetNameModel && (
            <div className="fixed top-50 left-50 w-full h-full bg-opacity-50 flex justify-center items-center popup-main rounded overflow-hidden widget-rename-model">
                <div className="bg-white p-3 rounded-lg shadow-lg">
                    <h3 className="text-lg font-semibold">Rename Widget</h3>
                    <label>Widget Name</label>
                    <input
                        type="text"
                        className="border p-2 w-full mt-2"
                        value={newWidgetName}
                        onChange={(e) => setNewWidgetName(e.target.value)}
                    />
                    <div className="mt-3 flex justify-end">
                        <button className="px-3 py-1 bg-gray-200 rounded mr-2" onClick={closeRenameWidgetNamePopup}>
                            Cancel
                        </button>
                        <button type="button" className="px-3 py-1 bg-blue-500 text-white rounded" onClick={saveWidgetName}>
                            Save
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>
  );
} 